export default "__VITE_ASSET__Dm4g$HZY__"